import React from 'react'
import complianceIcon from '../../../../assets/cardEntryIcons/compliance.svg';
import DataField from "../../utils/DataField"
import {getAlertsFlagIcon, getAlertsFlagColor, titleCase} from "../../utils/utils"



const fieldTitles = {
    package_id: "Identificador da Requisição Clear Sale",
    code: "Código do Pedido",
    score: "Score",
    status: "Status",
    session_id: "Sessão",
    date: "Data"
}

const fieldOrder = ["package_id", "code", "score", "status"]

const rootIgnoredKeys = ["data", "flag", "description"]


const getFieldTitle = (key) => {
    if (fieldTitles[key]) return fieldTitles[key]
    return titleCase(key.replace(/_/g, " "), key)
}


const getFieldLabel = (value) => {
    if (value == null) return null
    if (typeof value === "boolean") return value ? "Sim" : "Não"
    if (typeof value === "object") return null
    if (typeof value === "string" && value.trim() === "") return null
    return value.toString()
}


const getFieldPosition = (key) => {
    let position = fieldOrder.indexOf(key)
    if (position === -1) return fieldOrder.length
    return position
}


const buildFields = (object, ignoredKeys) => {
    let keys = Object.keys(object).filter(key => !ignoredKeys.includes(key))
    keys.sort((keyA, keyB) => getFieldPosition(keyA) - getFieldPosition(keyB))

    let fields = []
    keys.forEach(key => {
        let label = getFieldLabel(object[key])
        if (label == null) return
        fields.push({title: getFieldTitle(key), label: label})
    })
    return fields
}


const getPackages = (data) => {
    if (data == null) return []
    if (Array.isArray(data)) return data.filter(item => item != null && typeof item === "object" && !Array.isArray(item))
    if (typeof data === "object") return [data]
    return []
}


function ClearSaleFields(props) {

    if (props.fields.length === 0) return null

    return (
        <div className="smallerInternalCardContainer" style={{display: "flex", flexWrap: "wrap"}}>
            {props.fields.map((field, index) => (
                <div key={index} style={{flexGrow: "1", flexBasis: "220px", paddingRight: "20px"}}>
                    <DataField
                        title={field.title}
                        label={field.label}
                        size={"normalMediumSize"}
                        titleNoWrap={true}
                        margin="5px"
                        display={"inline"}
                        labelStyles={{wordBreak: "break-all"}}
                    />
                </div>
            ))}
        </div>
    )
}


function ClearSaleCard(props) {

    let clearsale = (((props.analysis_events || [])[0] || {}).decision_metadata || {}).clearsale

    if (clearsale == null || typeof clearsale !== "object" || Array.isArray(clearsale)) return null

    let rootFields = buildFields(clearsale, rootIgnoredKeys)
    let packages = getPackages(clearsale.data)
    let description = getFieldLabel(clearsale.description)

    if (description == null && rootFields.length === 0 && packages.length === 0) return null

    return (
        <div className="analysisCard">
            <div style={{display: "flex"}}>
                <img className="cardTitleIconStyle" src={complianceIcon} alt="complianceIcon Logo" />
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>ClearSale</span>
            </div>
            {description == null ? null :
            <div className="internalCardContainer" style={{display: "flex"}}>
                <div style={{display: "flex", margin: "auto 0px"}}>
                    {getAlertsFlagIcon(clearsale.flag)}
                </div>
                <div
                    className={["normalText", "normalMediumSize", "labelSpace"].join(" ")}
                    style={{marginTop: "auto", marginBottom: "auto", color: getAlertsFlagColor(clearsale.flag)}}
                >
                    {description}
                </div>
            </div>}
            <ClearSaleFields fields={rootFields}/>
            {packages.map((clearSalePackage, index) => (
                <div key={index}>
                    {packages.length === 1 ? null :
                    <div className={["blueText", "normalSmallSize", "bold"].join(" ")} style={{marginTop: "10px"}}>
                        {"PACOTE " + (index + 1)}
                    </div>}
                    <ClearSaleFields fields={buildFields(clearSalePackage, [])}/>
                </div>
            ))}
        </div>
    )
}


export default ClearSaleCard
